<template>
  <div class="home-board">
    <div class="home-kpis">
      <div v-for="k in kpis" :key="k.label" class="home-kpi">
        <em>{{ k.label }}</em>
        <b>{{ k.value }}<small v-if="k.unit">{{ k.unit }}</small></b>
        <span>{{ k.hint }}</span>
      </div>
    </div>

    <div class="home-body">
      <aside class="home-col">
        <div class="home-panel">
          <div class="stat-hd">服务记录结构</div>
          <screen-chart :options="mixChart" />
        </div>
        <div class="home-panel">
          <div class="stat-hd">有效订单分布</div>
          <screen-chart :options="orderChart" />
        </div>
      </aside>

      <section class="home-map">
        <div class="home-map-hole">
          <i class="mw-corner lt" /><i class="mw-corner rt" /><i class="mw-corner lb" /><i class="mw-corner rb" />
        </div>
      </section>

      <aside class="home-col">
        <div class="home-panel">
          <div class="stat-hd">服务记录排行</div>
          <screen-chart :options="rankChart" />
        </div>
        <div class="home-panel">
          <div class="stat-hd">服务人数排行</div>
          <screen-chart :options="userRankChart" />
        </div>
      </aside>
    </div>

    <div class="home-foot">
      <div class="home-foot-panel">
        <div class="stat-hd">各服务 · 服务记录</div>
        <screen-chart :options="recordChart" />
      </div>
      <div class="home-foot-panel">
        <div class="stat-hd">各服务 · 服务人数</div>
        <screen-chart :options="userChart" />
      </div>
    </div>
  </div>
</template>

<script>
import ScreenChart from './ScreenChart.vue'

export default {
  name: 'ScreenHome',
  components: { ScreenChart },
  props: {
    kpis: { type: Array, default() { return [] } },
    mixChart: { type: Object, default() { return {} } },
    rankChart: { type: Object, default() { return {} } },
    recordChart: { type: Object, default() { return {} } },
    userChart: { type: Object, default() { return {} } },
    orderChart: { type: Object, default() { return {} } },
    userRankChart: { type: Object, default() { return {} } }
  }
}
</script>

<style lang="scss" scoped>
.home-board {
  min-height: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  pointer-events: none;
}
.home-kpis {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  pointer-events: auto;
}
.home-kpi {
  position: relative;
  padding: 10px 14px 12px;
  overflow: hidden;
  border: 1px solid rgba(46, 230, 214, 0.32);
  background:
    linear-gradient(180deg, rgba(0, 90, 100, 0.35), rgba(6, 24, 40, 0.82));
  box-shadow: 0 0 18px rgba(46, 230, 214, 0.08) inset;
  em { display: block; font-style: normal; font-size: 12px; color: #7ec8d4; letter-spacing: 1px; }
  b {
    display: block; margin: 4px 0 2px; font-size: 28px; color: #e8fbff;
    text-shadow: 0 0 12px rgba(46, 230, 214, 0.45);
  }
  small { font-size: 12px; color: #7ec8d4; margin-left: 4px; }
  span { font-size: 11px; color: #6fa3ae; }
  &::after {
    content: '';
    position: absolute; right: -12px; top: -18px;
    width: 70px; height: 70px; border-radius: 50%;
    border: 1px solid rgba(46, 230, 214, 0.18);
  }
}
.home-body {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: 340px 1fr 340px;
  gap: 12px;
  pointer-events: none;
}
.home-col {
  min-height: 0;
  display: grid;
  grid-template-rows: 1fr 1fr;
  gap: 12px;
  pointer-events: auto;
}
.home-panel {
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 8px 6px 8px 8px;
  border: 1px solid rgba(46, 230, 214, 0.28);
  background: rgba(6, 24, 40, 0.88);
  box-shadow: 0 0 20px rgba(0, 40, 60, 0.25) inset;
  .stat-hd { margin: 0 0 4px; }
  ::v-deep .screen-chart { flex: 1; min-height: 0; height: auto; }
}
.home-map {
  min-height: 0;
  display: flex;
  flex-direction: column;
  pointer-events: none;
}
.home-map-hole {
  flex: 1;
  min-height: 80px;
  position: relative;
  border: 1px solid rgba(46, 230, 214, 0.35);
  background: transparent;
}
.mw-corner {
  position: absolute; width: 18px; height: 18px;
  border-color: #2ee6d6; border-style: solid;
  &.lt { top: -1px; left: -1px; border-width: 2px 0 0 2px; }
  &.rt { top: -1px; right: -1px; border-width: 2px 2px 0 0; }
  &.lb { bottom: -1px; left: -1px; border-width: 0 0 2px 2px; }
  &.rb { bottom: -1px; right: -1px; border-width: 0 2px 2px 0; }
}
.home-foot {
  height: 228px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  pointer-events: auto;
}
.home-foot-panel {
  min-width: 0;
  display: flex;
  flex-direction: column;
  padding: 8px 8px 4px;
  border: 1px solid rgba(46, 230, 214, 0.28);
  background: rgba(6, 24, 40, 0.88);
  .stat-hd { margin: 0 0 2px; }
  ::v-deep .screen-chart { flex: 1; min-height: 0; height: auto; }
}
.stat-hd {
  color: #2ee6d6; font-size: 13px; font-weight: 700;
  padding-left: 8px; border-left: 3px solid #2ee6d6;
}
</style>
